import { Button, Divider } from '@mui/material';
import PropTypes from 'prop-types';
import { FiGithub } from 'react-icons/fi';

const ConnectWithButtons = ({ githubButtonLabel, state }) => (
    <>
        <Divider
            textAlign="center"
            sx={{
                my: 2,
            }}
        >
            OR
        </Divider>
        <Button
            variant="outlined"
            href={`https://github.com/login/oauth/authorize?client_id=${
                process.env.NEXT_PUBLIC_GITHUB_CLIENT_ID
            }&state=${encodeURIComponent(JSON.stringify(state))}&scope=user:email`}
            color="dark"
            fullWidth
            startIcon={<FiGithub />}
        >
            {githubButtonLabel}
        </Button>
    </>
);

ConnectWithButtons.propTypes = {
    githubButtonLabel: PropTypes.string,
    state: PropTypes.object,
};
export default ConnectWithButtons;
